<sd-select theme="transparent">
  <ng-select
    [searchable]="false"
    [clearable]="false"
    placeholder="{{ placeholder }}"
    (change)="sortList($event)"
    [ngModel]="selectedOption"
    [attr.aria-label]="selectedLabel || placeholder"
    *ngIf="deviceService.isDesktopLgUp$ | async; else nativeSelect"
  >
    <ng-option *ngFor="let sort of sortOptions" [value]="sort.code">
      {{ sort.name || (sortLabels && sortLabels[sort.code]) }}
    </ng-option>
  </ng-select>
</sd-select>

<ng-template #nativeSelect>
  <div class="holder">
    <cx-icon [type]="iconType.SORT"></cx-icon>
    {{ selectedLabel || placeholder }}
  </div>
  <select
    (change)="sortList($event.target?.value)"
    [ngModel]="selectedOption"
    [attr.aria-label]="selectedLabel || placeholder"
  >
    <option *ngFor="let sort of sortOptions" [value]="sort.code">
      {{ sort.name || (sortLabels && sortLabels[sort.code]) }}
    </option>
  </select>
</ng-template>
